import { render, staticRenderFns } from "./History.vue?vue&type=template&id=ba0a5d6c&"
import script from "./History.vue?vue&type=script&lang=ts&"
export * from "./History.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba0a5d6c')) {
      api.createRecord('ba0a5d6c', component.options)
    } else {
      api.reload('ba0a5d6c', component.options)
    }
    module.hot.accept("./History.vue?vue&type=template&id=ba0a5d6c&", function () {
      api.rerender('ba0a5d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/History.vue"
export default component.exports